module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tooltip', _vm._b({}, 'el-tooltip', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-768e3bdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tooltip/rtTooltip.vue
// module id = 1533
// module chunks = 124